import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { ToolTipOptionsInterface } from './shared/tooltip-options.interface';
import { SatPopover } from '@ncstate/sat-popover';

const DEFAULT_TOOLTIP_OPTIONS: ToolTipOptionsInterface = {
    callOutInfoHead: null,
    callOutInfoText: null
};

@Component({
    selector: 'da-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TooltipComponent implements OnInit {
    @ViewChild(SatPopover) popover;
    @ViewChild('popover') p: SatPopover;

    @Input() option;

    @Output() opened: EventEmitter<boolean> = new EventEmitter();

    public showToolTip = false;
    public opening: boolean;

    constructor() {}

    ngOnInit() {}

    tellParentToCloseAllPopovers() {
        this.opening = true;
        this.opened.emit(true);
    }

    afterOpened() {
        this.opening = false;
    }
}
